<template>
  <div class="engineer-container">
    <div class="content-wrapper">
      <!-- 页面标题 -->
      <div style="position: relative;display: inline-block;margin-bottom: 30px;">
        <div class="page-title">认证供应商</div>
        <div class="page-title-line" />
      </div>

      <!-- 个人注册表单 -->
      <div class="form-section">
        <div
          class="form-fields"
          style="margin-top: 20px;"
        >
          <div class="form-item">
            <label>身份证正反面</label>
            <div class="upload-area">
              <div class="upload-item">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('id_card_front')"
                >
                  <img
                    v-if="previewImages.id_card_front"
                    :src="previewImages.id_card_front"
                    alt="身份证正面"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-camera-solid" />
                    <div class="upload-text">上传身份证正面</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_id_card_front"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'id_card_front')"
                >
              </div>
              <div class="upload-item">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('id_card_back')"
                >
                  <img
                    v-if="previewImages.id_card_back"
                    :src="previewImages.id_card_back"
                    alt="身份证反面"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-camera-solid" />
                    <div class="upload-text">上传身份证反面</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_id_card_back"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'id_card_back')"
                >
              </div>
            </div>
          </div>
          <div class="form-item">
            <label>资格证书上传</label>
            <div class="upload-area">
              <div class="upload-item large">
                <div
                  class="upload-placeholder"
                  :class="{ uploading: uploading }"
                  @click="triggerFileInput('business_license')"
                >
                  <img
                    v-if="previewImages.business_license"
                    :src="previewImages.business_license"
                    alt="资格证书"
                    class="preview-img"
                  >
                  <div v-else class="upload-content">
                    <i class="el-icon-document" />
                    <div class="upload-text">上传资格证书</div>
                  </div>
                  <div v-if="uploading" class="upload-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <input
                  ref="fileInput_business_license"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleImageUpload($event, 'business_license')"
                >
              </div>
            </div>
          </div>
          <div class="form-item">
            <label>公司名称</label>
            <el-input
              v-model="form.company_name"
              placeholder="请输入公司名称"
            />
          </div>
          <div class="form-item">
            <label>姓名</label>
            <el-input
              v-model="form.name"
              placeholder="请输入你的姓名"
            />
          </div>
          <div class="form-item">
            <label>电话号码</label>
            <el-input
              v-model="form.phone"
              placeholder="请输入你的电话号码"
            />
          </div>

          <!-- <div class="form-item">
            <label>验证码</label>
            <div class="code-input-wrapper">
              <el-input
                v-model="individualForm.code"
                placeholder="请输入你的验证码"
              />
              <el-button
                type="text"
                class="code-btn"
                :disabled="codeCountdown > 0"
                @click="sendCode"
              >
                {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
              </el-button>
            </div>
          </div> -->

          <!-- <div class="form-item">
            <label>其他联系方式(非必填)</label>
            <el-input
              v-model="individualForm.otherContact"
              placeholder="请输入其他联系方式"
            />
          </div> -->
        </div>
      </div>

      <!-- 注册按钮 -->
      <div class="submit-section">
        <el-button
          type="primary"
          class="submit-btn"
          :loading="loading"
          @click="handleSubmit"
        >
          提交
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { submitSupplierInfo, uploadImage } from '@/api/user'
import { removeToken } from '@/utils/auth'

export default {
  name: 'Supplier',
  data() {
    return {
      loading: false,
      uploading: false,
      codeCountdown: 0,
      previewImages: {
        id_card_front: '',
        id_card_back: '',
        business_license: ''
      },
      form: {
        business_license: '', // 资格证书（营业执照）
        company_name: '', // 公司名称
        name: '', // 姓名
        phone: '', // 手机号
        id_card_front: '', // 身份证正面
        id_card_back: '' // 身份证反面
      }
    }
  },
  methods: {
    // 处理图片上传
    handleImageUpload(event, fieldName) {
      const file = event.target.files[0]
      if (!file) return

      // 验证文件类型
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('只支持 JPG、JPEG、PNG 格式的图片')
        return
      }

      // 验证文件大小（5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过 5MB')
        return
      }

      this.uploadImageFile(file, fieldName)
    },
    // 上传图片文件
    async uploadImageFile(file, fieldName) {
      this.uploading = true

      try {
        const response = await uploadImage(file)
        if (response.code === 1) {
          // 保存图片URL到表单数据
          this.form[fieldName] = response.data.url || response.data
          // 保存预览图片
          this.previewImages[fieldName] = URL.createObjectURL(file)
          this.$message.success('图片上传成功')
        } else {
          this.$message.error(response.msg || '图片上传失败')
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        this.$message.error('图片上传失败，请重试')
      } finally {
        this.uploading = false
      }
    },
    // 触发文件选择
    triggerFileInput(fieldName) {
      this.$refs[`fileInput_${fieldName}`].click()
    },
    // 表单提交
    async handleSubmit() {
      // 表单验证
      if (!this.validateForm()) {
        return
      }

      this.loading = true

      try {
        const response = await submitSupplierInfo(this.form)
        if (response.code === 1) {
          this.$message.success('注册提交成功')
          // 注册成功后删除token并返回登录页
          removeToken()
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500) // 1.5秒后跳转，让用户看到成功提示
        } else {
          this.$message.error(response.msg || '提交失败')
        }
      } catch (error) {
        console.error('提交供应商信息失败:', error)
        this.$message.error('提交失败，请重试')
      } finally {
        this.loading = false
      }
    },
    // 表单验证
    validateForm() {
      const { business_license, company_name, name, phone, id_card_front, id_card_back } = this.form

      if (!business_license) {
        this.$message.error('请上传资格证书')
        return false
      }

      if (!company_name) {
        this.$message.error('请输入公司名称')
        return false
      }

      if (!name) {
        this.$message.error('请输入姓名')
        return false
      }

      if (!phone) {
        this.$message.error('请输入手机号')
        return false
      }

      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('请输入正确的手机号')
        return false
      }

      if (!id_card_front || !id_card_back) {
        this.$message.error('请上传身份证正反面')
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.engineer-container {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/image/bg3.png') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  box-sizing: border-box;
}

.content-wrapper {
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  width: var(--page-inner-ratio, 80%);
  max-width: 800px;
  max-height: calc(100vh - var(--navbar-total-height, 80px) - 40px);
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);

  @supports (height: 100dvh) {
    max-height: calc(100dvh - var(--navbar-total-height, 80px) - 40px);
  }

  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  .page-title {
    font-size: 28px;
    font-weight: 600;
    color: #111111;
  }

  .page-title-line{
	width: 120px;
	height: 5px;
	background: #0F6FE2;
	border-radius: 3px;
	position: absolute;
	left: 50%;
	bottom: -10px;
	transform: translateX(-50%);
  }

  .form-section {
    margin-bottom: 30px;

    .form-fields {
      .form-item {
        margin-bottom: 20px;

        label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-bottom: 8px;
        }

        .el-input {
          width: 100%;
        }

        .code-input-wrapper {
          display: flex;
          gap: 10px;

          .el-input {
            flex: 1;
          }

          .code-btn {
            color: #0f6fe2;
            font-weight: 500;
            white-space: nowrap;
          }
        }

        .upload-area {
          display: flex;
          gap: 15px;

          .upload-item {
            flex: 1;

            &.large {
              flex: 2;
            }

            .upload-placeholder {
              height: 120px;
              border: 2px dashed #d9d9d9;
              border-radius: 8px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;

              &:hover {
                border-color: #0f6fe2;
                background: #f0f8ff;
              }

              &.uploading {
                border-color: #0f6fe2;
                background: #f0f8ff;
                cursor: not-allowed;
              }

              .upload-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                i {
                  font-size: 24px;
                  color: #999;
                  margin-bottom: 8px;
                }

                .upload-text {
                  font-size: 12px;
                  color: #999;
                }
              }

              .preview-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 6px;
              }

              .upload-loading {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;

                i {
                  font-size: 20px;
                  color: #0f6fe2;
                }
              }
            }

            .id-card-img {
              width: 100%;
              object-fit: cover;
              border-radius: 8px;
              transition: all 0.3s ease;

              &:hover {
                transform: scale(1.02);
              }
            }

            .certificate-img {
              width: 50%;
              object-fit: cover;
              border-radius: 8px;
              transition: all 0.3s ease;

              &:hover {
                transform: scale(1.02);
              }
            }
          }
        }
      }
    }
  }

  .submit-section {
    text-align: center;
    margin-top: 40px;

    .submit-btn {
      width: 100%;
      height: 50px;
      font-size: 18px;
      font-weight: 600;
      background: #0f6fe2;
      border: none;
      border-radius: 8px;

      &:hover {
        background: #0c5bc7;
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(15, 111, 226, 0.3);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .engineer-container {
    padding: 60px 20px;
  }

  .content-wrapper {
    padding: 30px 20px;

    .page-title {
      font-size: 24px;
      margin-bottom: 30px;
    }

    .form-section {
      .form-fields {
        .form-item {
          .upload-area {
            flex-direction: column;
            gap: 10px;
          }
        }
      }
    }

    .submit-section {
      .submit-btn {
        width: 100%;
      }
    }
  }
}
</style>
